/* Encontra o cafe perfeito - quiz engine

   Question count comes from quiz-data.json, so adding questions 4 and 5 is a
   data change rather than a code change.

   Answers are mirrored into the URL (?r=A-B-C) so a result can be shared or
   reloaded. Roast, origin, tasting notes and brewing methods come from the
   portela.* metafields; each block is skipped when its field is empty, which
   is the state for every product today. */

(function () {
  'use strict';

  var SVG = {
    tick: '<svg viewBox="0 0 24 24" fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    star: '<svg viewBox="0 0 24 24"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    chevronL: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    chevronR: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>'
  };

  function money(v) { return '€' + Number(v).toFixed(2).replace('.', ','); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function pills(items) {
    return '<ul class="pq__pills">' + items.map(function (n) {
      return '<li class="pq__pill">' + esc(n) + '</li>';
    }).join('') + '</ul>';
  }

  function PortelaQuiz(root) {
    this.root = root;
    this.lang = root.dataset.lang || 'en';
    this.answers = [];
    this.index = 0;

    var node = root.querySelector('[data-quiz-products]');
    try { this.live = JSON.parse((node && node.textContent) || '{}'); }
    catch (err) { this.live = {}; }

    this.el = {
      panelQuiz: root.querySelector('[data-panel="quiz"]'),
      panelResult: root.querySelector('[data-panel="result"]'),
      subtitle: root.querySelector('[data-subtitle]'),
      fill: root.querySelector('[data-progress-fill]'),
      label: root.querySelector('[data-progress-label]'),
      question: root.querySelector('[data-question]'),
      options: root.querySelector('[data-options]'),
      back: root.querySelector('[data-back]'),
      skip: root.querySelector('[data-skip]'),
      result: root.querySelector('[data-result]'),
      live: root.querySelector('[data-live-region]')
    };

    this.load();
  }

  PortelaQuiz.prototype.load = function () {
    var self = this;
    Promise.all([
      fetch(this.root.dataset.dataUrl, { cache: 'no-cache' }).then(function (r) { return r.json(); }),
      fetch(this.root.dataset.catalogUrl, { cache: 'no-cache' }).then(function (r) { return r.json(); })
    ])
      .then(function (both) {
        var data = both[0];
        self.data = data;
        self.catalog = (both[1] && both[1].products) || [];
        var copy = data.page;
        var subtitle = typeof copy.subtitle === 'string'
          ? copy.subtitle
          : (copy.subtitle[self.lang] || copy.subtitle.en);
        /* {n} follows total(), so a preview limited to one question does not
           still promise eleven. */
        self.el.subtitle.textContent = String(subtitle).replace('{n}', self.total());
        self.el.back.innerHTML = SVG.chevronL + '<span>' + esc(copy.back) + '</span>';
        self.el.skip.textContent = copy.skip;
        self.el.back.addEventListener('click', function () { self.go(self.index - 1); });
        self.el.skip.addEventListener('click', function () {
          window.location.href = self.root.dataset.skipUrl;
        });
        self.el.options.addEventListener('keydown', self.onKeydown.bind(self));
        window.addEventListener('popstate', function () { self.fromUrl(); });
        self.fromUrl();
      })
      .catch(function () {
        self.el.question.textContent = 'Não foi possível carregar o questionário.';
      });
  };

  /* `preview_questions` lets the section show only the first N questions so the
     flow can be shown to stakeholders without walking all 11. 0 = show all.
     It only limits what is asked; nothing is deleted. */
  PortelaQuiz.prototype.total = function () {
    var all = this.data.questions.length;
    var limit = parseInt(this.root.dataset.previewQuestions || '0', 10);
    return (limit > 0 && limit < all) ? limit : all;
  };

  /* ------------------------------------------------------------ url state */

  PortelaQuiz.prototype.fromUrl = function () {
    var raw = new URLSearchParams(window.location.search).get('r');
    var parts = raw ? raw.split('-').filter(Boolean) : [];
    var valid = parts.length === this.total() && parts.every(function (p, i) {
      return this.data.questions[i].options.some(function (o) { return o.value === p; });
    }, this);

    if (valid) {
      this.answers = parts;
      this.finish(true);
    } else {
      this.answers = [];
      this.index = 0;
      this.el.panelResult.hidden = true;
      this.el.panelQuiz.hidden = false;
      this.render();
    }
  };

  PortelaQuiz.prototype.pushUrl = function (value, replace) {
    var url = new URL(window.location.href);
    if (value) url.searchParams.set('r', value);
    else url.searchParams.delete('r');
    window.history[replace ? 'replaceState' : 'pushState']({}, '', url);
  };

  /* -------------------------------------------------------------- questions */

  PortelaQuiz.prototype.go = function (i) {
    if (i < 0) return;
    this.index = i;
    this.render();
    this.announce(this.data.questions[i].title + ', ' + (i + 1) + ' / ' + this.total());
  };

  PortelaQuiz.prototype.announce = function (text) {
    if (this.el.live) this.el.live.textContent = text;
  };

  PortelaQuiz.prototype.render = function () {
    var self = this;
    var q = this.data.questions[this.index];
    var key = this.lang === 'pt' ? 'label_pt' : 'label';  /* new data carries `label` only */

    this.el.fill.style.width = ((this.index + 1) / this.total()) * 100 + '%';
    this.el.label.textContent = (this.index + 1) + ' / ' + this.total();
    this.el.question.textContent = q.title;
    /* The design keeps Back visible on question 1, greyed out, so the
       row stays balanced against Skip Quiz. */
    this.el.back.disabled = this.index === 0;

    this.el.options.innerHTML = '';
    q.options.forEach(function (opt, i) {
      var checked = self.answers[self.index] === opt.value;
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pq__option';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', checked ? 'true' : 'false');
      /* roving tabindex: one stop for the whole group */
      btn.tabIndex = checked || (!self.answers[self.index] && i === 0) ? 0 : -1;
      btn.innerHTML = '<span>' + esc(opt[key] || opt.label) + '</span>' +
                      '<span class="pq__tick">' + SVG.tick + '</span>';
      btn.addEventListener('click', function () { self.choose(opt.value); });
      li.appendChild(btn);
      self.el.options.appendChild(li);
    });
  };

  PortelaQuiz.prototype.onKeydown = function (e) {
    var items = Array.prototype.slice.call(this.el.options.querySelectorAll('.pq__option'));
    var at = items.indexOf(document.activeElement);
    if (at === -1) return;
    var next = null;

    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (at + 1) % items.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (at - 1 + items.length) % items.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = items.length - 1;
    else return;

    e.preventDefault();
    items.forEach(function (b) { b.tabIndex = -1; });
    items[next].tabIndex = 0;
    items[next].focus();
  };

  PortelaQuiz.prototype.choose = function (value) {
    var self = this;
    this.answers[this.index] = value;
    this.answers.length = this.index + 1;   /* changing an answer invalidates later ones */
    this.render();
    window.setTimeout(function () {
      if (self.index + 1 < self.total()) self.go(self.index + 1);
      else self.finish();
    }, 260);
  };

  /* ------------------------------------------------------------- scoring

     11 questions = 2,359,296 answer combinations, so there is no lookup table.
     Each chosen option carries `effects` that either filter the catalogue
     (format, decaf) or score it. Mirrors quiz/build/score_reference.py, which
     is the tested reference implementation - change both together. */
  /* The client's spreadsheet states a coffee for all 64 combinations, so when a
     lookup table is present it wins outright. Scoring is kept below only as a
     fallback for data files that still carry `effects`; it must never be allowed
     to disagree with the table. */
  PortelaQuiz.prototype.lookupResult = function () {
    var key = this.answers.join('-');
    var handle = this.data.lookup[key];
    var self = this;
    function find(h) {
      for (var i = 0; i < self.catalog.length; i++) {
        if (self.catalog[i].handle === h) return self.catalog[i];
      }
      return null;
    }
    var chosen = handle ? find(handle) : null;
    if (!chosen) return { ranked: [], relaxed: false, format: null };
    /* "Pode gostar de..." - other coffees in the same format, stable order. */
    var others = this.catalog.filter(function (p) {
      return p.handle !== chosen.handle && p.format === chosen.format && p.available !== false;
    }).slice(0, 4).map(function (p) { return { product: p, score: 0 }; });
    return { ranked: [{ product: chosen, score: 1 }].concat(others),
             relaxed: false, format: chosen.format };
  };

  PortelaQuiz.prototype.score = function () {
    if (this.data && this.data.lookup) return this.lookupResult();

    var self = this;
    var effects = [];
    this.data.questions.forEach(function (q, i) {
      var chosen = self.answers[i];
      if (!chosen) return;
      q.options.forEach(function (o) { if (o.value === chosen) effects.push(o.effects || {}); });
    });

    function firstEffect(key) {
      for (var i = 0; i < effects.length; i++) {
        if (Object.prototype.hasOwnProperty.call(effects[i], key)) return effects[i][key];
      }
      return null;
    }

    /* hard filters - the client's priority 1 (format) and 2 (caffeine) */
    var fmt = firstEffect('filter_format');
    var decaf = firstEffect('filter_decaf');
    var pool = this.catalog.filter(function (p) {
      if (fmt && p.format !== fmt) return false;
      if (decaf !== null && p.decaf !== decaf) return false;
      return true;
    });

    /* Never dead-end: drop the decaf preference before the format requirement,
       because format is physical compatibility and decaf is a preference. */
    var relaxed = false;
    if (!pool.length) {
      relaxed = true;
      pool = this.catalog.filter(function (p) { return !fmt || p.format === fmt; });
    }

    var ranked = pool.map(function (p) {
      var s = 0;
      effects.forEach(function (e) {
        var w = e.weight || 0;
        if (e.profile && p.profile && p.profile[e.profile]) {
          s += w * Math.min(p.profile[e.profile], 3) / 3;
        }
        if (e.sensory && p.sensory && p.sensory[e.sensory]) {
          s += w * Math.min(p.sensory[e.sensory], 3) / 3;
        }
        if (typeof e.intensity_target === 'number') {
          s += w * Math.max(0, 1 - Math.abs((p.intensity || 6) - e.intensity_target) / 6);
        }
        if (e.boost_decaf && p.decaf) s += e.boost_decaf;
        if (e.prefer) {
          var isBlend = /mistura|blend|lote|portela/i.test(p.title || '');
          if ((e.prefer === 'blend') === isBlend) s += w;
        }
      });
      /* stable tie-break so the same answers always give the same coffee */
      var h = 0, t = p.handle || '';
      for (var i = 0; i < t.length; i++) { h = (h * 31 + t.charCodeAt(i)) % 9973; }
      return { product: p, score: s + h / 1000000 };
    });

    ranked.sort(function (a, b) { return b.score - a.score; });
    return { ranked: ranked, relaxed: relaxed, format: fmt };
  };

  PortelaQuiz.prototype.finish = function (fromUrl) {
    var result = this.score();
    var top = result.ranked[0];
    var combo = top ? {
      product: this.resolve(top.product),
      scored: top.product,
      alternatives: result.ranked.slice(1, 5),
      relaxed: result.relaxed,
      format: result.format
    } : null;
    this.el.panelQuiz.hidden = true;
    this.el.panelResult.hidden = false;
    this.root.classList.add('pq--done');
    if (!fromUrl) this.pushUrl(this.answers.join('-'));
    this.renderResult(combo);
    this.announce(this.data.page.result_title);
    if (!fromUrl) this.el.panelResult.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* Live Shopify data wins over the precomputed catalogue - but only where it
     actually has a value.

     Measured on the store: Shopify stops resolving metafields inside an
     `all_products` loop after roughly 21 products, so `custom.notas` and
     friends come back as "" for the tail of the list while price, stock and
     variant id still resolve for all 31. A plain Object.assign would let those
     empty strings wipe out good data from quiz-products.json, silently
     stripping tasting notes from ten coffees. */
  PortelaQuiz.prototype.resolve = function (snap) {
    if (!snap) return null;
    var live = this.live[snap.handle] || {};
    var out = Object.assign({}, snap);
    Object.keys(live).forEach(function (k) {
      var v = live[k];
      if (v === null || v === undefined || v === '') return;
      if (Array.isArray(v) && !v.length) return;
      out[k] = v;
    });
    return out;
  };

  PortelaQuiz.prototype.renderResult = function (combo) {
    var self = this;
    var copy = this.data.page;
    var out = ['<h2 class="pq__result-title">' + esc(copy.result_title) + '</h2>'];

    if (!combo || !combo.product) {
      out.push('<div class="pq__gap">' + esc(copy.empty || 'Não encontrámos um café para estas respostas.') + '</div>');
      this.el.result.innerHTML = out.join('');
      return;
    }

    var p = this.resolve(combo.product);
    out.push('<p class="pq__result-subtitle">' + esc(copy.result_subtitle) + '</p>');

    if (combo.relaxed) {
      out.push('<p class="pq__gap">Não temos descafeinado neste formato, por isso mostramos a ' +
               'melhor alternativa com cafeína.</p>');
    }
    out.push(this.matchMarkup(p));

    out.push(
      '<div class="pq__result-actions">' +
        '<button type="button" class="pq__btn pq__btn--ghost" data-retake>' +
          SVG.chevronL + 'Recomeçar' + '</button>' +
        '<a class="pq__btn pq__btn--solid" href="' + esc(this.root.dataset.collectionUrl) + '">' +
          'Ver todos os cafés' + SVG.chevronR + '</a>' +
      '</div>'
    );

    if (p) out.push(this.relatedMarkup(combo, p));
    out.push(this.subscribeMarkup());

    this.el.result.innerHTML = out.join('');

    var retake = this.el.result.querySelector('[data-retake]');
    if (retake) retake.addEventListener('click', function () { self.reset(); });
    this.el.result.querySelectorAll('[data-add]').forEach(function (b) {
      b.addEventListener('click', function () { self.addToCart(b.dataset.add, b); });
    });
  };

  /* `Notas` is one free-text metafield ("Chocolate, nozes, baixa acidez"), not a
     list, so it is split for the pills. There is no roast or brewing-method
     metafield on this store - the design's "DARK ROAST" line uses Intensidade,
     and the brewing-methods chips are omitted rather than faked. */
  function noteList(p) {
    if (Array.isArray(p.notes)) return p.notes;
    var raw = p.notes || p.notes_raw || '';
    if (!raw) return p.note_tokens || [];
    return raw.split(/[,;.]| e /).map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 2 && s.length < 40; });
  }

  function intensityLabel(p) {
    var v = p.intensity;
    if (v === null || v === undefined || v === '') return '';
    var n = parseInt(String(v), 10);
    if (isNaN(n)) return String(v);
    /* Stored 1-10, displayed 1-5 to match the Figma. Odd values show a half step. */
    var label = n % 2 === 0 ? String(n / 2) : String((n - 1) / 2) + ',5';
    return 'Intensidade ' + label + '/5';
  }

  PortelaQuiz.prototype.matchMarkup = function (p) {
    var notes = noteList(p);
    var eyebrow = intensityLabel(p);
    var hasDetail = eyebrow || p.origin || p.description || notes.length;
    var out = ['<article class="pq__match"><div class="pq__match-media">'];

    if (p.rating) out.push('<span class="pq__rating">' + SVG.star + esc(p.rating) + '</span>');
    out.push('<img src="' + esc(p.image) + '" alt="' + esc(p.title) +
             '" width="380" height="570" loading="lazy">');
    out.push('</div><div class="pq__match-body' + (hasDetail ? '' : ' pq__match-body--bare') + '">');

    if (eyebrow) out.push('<p class="pq__eyebrow">' + esc(eyebrow) + '</p>');
    out.push('<h3 class="pq__match-name">' + esc(p.title) + '</h3>');
    if (p.description) out.push('<p class="pq__match-desc">' + esc(p.description) + '</p>');
    if (p.origin) out.push('<p class="pq__label">Origem</p><p class="pq__origin">' + esc(p.origin) + '</p>');
    if (notes.length) out.push('<p class="pq__label">Notas</p>' + pills(notes));

    out.push(
      '<div class="pq__buy">' +
        '<div><p class="pq__label">Preço</p>' +
        '<p class="pq__price-value">' + money(p.price) + '</p></div>' +
        (p.variant_id
          ? '<button type="button" class="pq__btn pq__btn--solid" data-add="' + esc(p.variant_id) + '">' +
            SVG.cart + 'Adicionar ao carrinho</button>'
          : '<a class="pq__btn pq__btn--solid" href="' + esc(p.url) + '">Ver produto</a>') +
      '</div></div></article>'
    );
    return out.join('');
  };

  /* "Pode gostar de..." is now the genuine runners-up from the same scoring
     pass, not an arbitrary slice of the same format. That also matters for
     catalogue coverage: several coffees tie on the data available today, and
     showing the near-misses stops one of them always being the only one seen. */
  PortelaQuiz.prototype.relatedMarkup = function (combo, chosen) {
    var self = this;
    var pool = (combo.alternatives || []).map(function (a) {
      return self.resolve(a.product);
    }).filter(function (p) { return p && p.handle !== chosen.handle; }).slice(0, 4);

    if (!pool.length) return '';

    var cards = pool.map(function (p) {
      var notes = noteList(p).slice(0, 3);
      return '<li class="pq__card">' +
        '<a class="pq__card-media" href="' + esc(p.url) + '">' +
          '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' +
          (p.rating ? '<span class="pq__card-rating">' + SVG.star + esc(p.rating) + '</span>' : '') +
        '</a>' +
        '<div class="pq__card-body">' +
          (intensityLabel(p) ? '<p class="pq__eyebrow">' + esc(intensityLabel(p)) + '</p>' : '') +
          '<h4 class="pq__card-name"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h4>' +
          (p.description ? '<p class="pq__card-desc">' + esc(p.description) + '</p>' : '') +
          (notes.length ? pills(notes) : '') +
          '<div class="pq__card-foot">' +
            '<span class="pq__card-price">' + money(p.price) + '</span>' +
            (p.variant_id
              ? '<button type="button" class="pq__icon-btn" data-add="' + esc(p.variant_id) +
                '" aria-label="Adicionar ' + esc(p.title) + ' ao carrinho">' + SVG.cart + '</button>'
              : '<a class="pq__icon-btn" href="' + esc(p.url) + '" aria-label="Ver ' + esc(p.title) + '">' +
                SVG.chevronR + '</a>') +
          '</div>' +
        '</div></li>';
    }).join('');

    return '<section><h3 class="pq__related-title">Pode gostar de...</h3>' +
      '<p class="pq__related-note">Explore estas outras excelentes opções de café, ' +
      'tendo como base as respostas ao seu quiz</p>' +
      '<ul class="pq__grid">' + cards + '</ul></section>';
  };

  /* Both bullets state real terms, verified against the live selling plan on
     2026-09-29: group "Subscreva e poupe", plan "Entregar todos os meses,
     3% de desconto" (price_adjustment 3%). Free shipping is threshold-based at
     EUR 49, not a subscription perk. Do not restore "10%" or "free shipping on
     all subscriptions" without re-checking /products/<handle>.js. */
  PortelaQuiz.prototype.subscribeMarkup = function () {
    return '<section class="pq__subscribe">' +
      '<div>' +
        '<h3>Nunca fique sem<br>o seu café</h3>' +
        '<p>Inscreva-se e receba o seu café favorito regularmente. Personalize o seu ' +
        'calendário de entregas, altere ou cancele a qualquer momento.</p>' +
        '<ul class="pq__checks">' +
          '<li>' + SVG.tick + 'Envio grátis acima de €49</li>' +
          '<li>' + SVG.tick + '3% de desconto em cada entrega</li>' +
        '</ul>' +
        '<a class="pq__btn pq__btn--ghost" href="' + esc(this.root.dataset.subscriptionUrl) + '">' +
          'Adquira a sua subscrição' + SVG.chevronR + '</a>' +
      '</div>' +
      '<div class="pq__subscribe-media" role="presentation"></div></section>';
  };

  PortelaQuiz.prototype.addToCart = function (variantId, btn) {
    if (!variantId) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function () {
      btn.disabled = false;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () { btn.disabled = false; });
  };

  PortelaQuiz.prototype.reset = function () {
    this.root.classList.remove('pq--done');
    this.answers = [];
    this.index = 0;
    this.pushUrl(null);
    this.el.panelResult.hidden = true;
    this.el.panelQuiz.hidden = false;
    this.render();
    this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  document.querySelectorAll('[data-portela-quiz]').forEach(function (el) {
    new PortelaQuiz(el);
  });
})();
